import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import AdminIndex from '@routes/Home/routes/AdminPortal/routes/AdminIndex';
import RolesConfigure from '@routes/Home/routes/AdminPortal/routes/RolesConfigure';
import RolesPermsDetails from '@routes/Home/routes/AdminPortal/routes/RolesPermsDetails';
import SchoolManage from '@routes/Home/routes/AdminPortal/routes/SchoolManage';
import OrganizationSettings from '@routes/Home/routes/AdminPortal/routes/OrganizationSettings';
import CalendarsViews from '@routes/Home/routes/AdminPortal/routes/Calendars';
import { reducer } from '@routes/Home/routes/AdminPortal/Modules/Module';
import ExamGradingSetup from '@routes/Home/routes/AdminPortal/routes/ExamGradingSetup';
import ModuleSettings from '@routes/Home/routes/AdminPortal/routes/ModuleSettings';
import ReportConfiguration from './routes/ReportConfiguration';
import CustomFields from './routes/CustomFields';
import MessageTemplates from './routes/MessageTemplates';
import Transport from './routes/Transport';
import FeeConfiguration from './routes/FeeConfiguration';

const AdminPortalLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'AdminPortal' */ './components/AdminPortal')
);

export default (store) => {
	store.injectReducer('admin', reducer);
	return {
		path: '/admin',
		element: (
			<AsyncLoading
				component={<AdminPortalLazy permission="ShowAdminPortal" />}
			/>
		),
		children: [
			AdminIndex(store),
			RolesConfigure(store),
			RolesPermsDetails(store),
			SchoolManage(store),
			OrganizationSettings(store),
			CalendarsViews(store),
			...ExamGradingSetup(store),
			ModuleSettings(store),
			...ReportConfiguration(store),
			...CustomFields(store),
			MessageTemplates(store),
			...Transport(store),
			FeeConfiguration(store),
		],
	};
};
